import { render, staticRenderFns } from "./SummaryChart.vue?vue&type=template&id=2c9f52d3&scoped=true"
import script from "./SummaryChart.vue?vue&type=script&lang=js"
export * from "./SummaryChart.vue?vue&type=script&lang=js"
import style0 from "./SummaryChart.vue?vue&type=style&index=0&id=2c9f52d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9f52d3",
  null
  
)

export default component.exports